var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorld(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12,22c-5.52,0-10-4.48-10-10S6.48,2,12,2s10,4.48,10,10-4.48,10-10,10Zm-2.29-2.33c-.99-2.09-1.56-4.36-1.68-6.67h-3.97c.19,1.54.83,2.99,1.83,4.17,1,1.18,2.33,2.05,3.81,2.5Zm.32-6.67c.15,2.44.85,4.73,1.97,6.75,1.15-2.08,1.83-4.38,1.97-6.75h-3.94Zm9.91,0h-3.97c-.12,2.31-.7,4.57-1.68,6.67,1.49-.44,2.81-1.31,3.81-2.5,1-1.18,1.64-2.63,1.83-4.17Zm-15.88-2h3.97c.12-2.31.7-4.57,1.68-6.67-1.49.44-2.81,1.31-3.81,2.5-1,1.18-1.64,2.63-1.83,4.17Zm5.97,0h3.94c-.14-2.37-.82-4.68-1.97-6.75-1.15,2.08-1.83,4.38-1.97,6.75h0Zm4.26-6.67c.99,2.09,1.56,4.36,1.68,6.67h3.97c-.19-1.54-.83-2.99-1.83-4.17-1-1.18-2.33-2.05-3.81-2.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorld);
export default __webpack_public_path__ + "static/media/world.378a4ddf023df34f7cabeca867ecb63a.svg";
export { ForwardRef as ReactComponent };